import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import SeasonalBanner from '../components/SeasonalBanner';
import Footer from '../components/Footer';
import { useLang } from '../LanguageContext';
import { useTheme } from '../ThemeContext';
import { legalContent } from '../legal';

const LegalPage = ({ type = 'mentions' }) => {
  const { lang } = useLang();
  const theme = useTheme();
  const content = legalContent[type]?.[lang] || legalContent[type]?.fr;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [type]);

  if (!content) return null;

  return (
    <div className="min-h-screen" style={{ background: '#f6ecd9' }}>
      <SeasonalBanner />
      <Navbar />

      <section
        className="relative pb-16 overflow-hidden"
        style={{ background: theme.primary, paddingTop: 'calc(var(--banner-h, 0px) + 160px)' }}
      >
        <div
          className="absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage: 'radial-gradient(#d4a94c 1px, transparent 1px)',
            backgroundSize: '28px 28px'
          }}
        />
        <div className="relative max-w-4xl mx-auto px-6">
          <p className="text-[11px] tracking-[0.35em] uppercase text-[#d4a94c] mb-6 fade-up">
            {content.updated}
          </p>
          <h1 className="font-serif text-4xl md:text-6xl text-[#f6ecd9] leading-[1.08] fade-up fade-up-delay-1">
            {content.title}
          </h1>
        </div>
      </section>

      <section className="bg-[#f6ecd9] py-20">
        <div className="max-w-3xl mx-auto px-6">
          <div className="space-y-14">
            {content.sections.map((s, i) => (
              <div key={i}>
                <div className="flex items-center gap-4 mb-5">
                  <span className="text-[#d4a94c] font-serif text-xl">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="h-px flex-1 bg-[#0d1b36]/15" />
                </div>
                <h2 className="font-serif text-2xl md:text-3xl text-[#0d1b36] mb-5">
                  {s.heading}
                </h2>
                <div className="space-y-3 text-[15px] leading-relaxed text-[#0d1b36]/80">
                  {s.body.map((line, j) => (
                    <p key={j}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LegalPage;
